import log from 'loglevel'

/**
 * NDJSONローダー
 */
export default class NdjsonLoader {
  /**
   * コンストラクタ
   * @param {Number} chunkSize iteration時の返却データ件数目安
   */
  constructor(chunkSize) {
    this.chunkSize = +chunkSize || 1000
    this._isLoading = false
    this._toAbort = false
    this._reader = null
    this._abortTimeoutMs = 5000
  }

  /**
   * ロード中の場合はtrue
   * @type {Boolean}
   */
  get isLoading() {
    return this._isLoading
  }

  /**
   * ロード
   * @param {StreamReader} reader
   */
  async *load(reader) {
    this._isLoading = true

    // 別の読み込みがある場合は中断する
    if (this._reader) {
      log.debug('abort preceding request')
      await this.abort()
    }

    this._reader = reader
    const decoder = new TextDecoder()
    let data = []
    let chars = ''
    let iterCount = 0
    try {
      while (true) {
        if (this._toAbort) {
          log.debug('start abort')
          return
        }
        const { done, value } = await this._reader.read()
        if (done) {
          if (iterCount === 0) {
            // データがない
            log.info('no data in this reader')
            yield []
          } else if (data.length) {
            yield data
          }
          log.info('read done')
          this._closeReader()
          return
        }

        chars += decoder.decode(value)
        const texts = chars.split('\n')
        for (const t of texts) {
          try {
            data.push(JSON.parse(t))
          } catch {
            log.debug('parse error', t)
            chars = t
          }
        }
        if (data.length >= this.chunkSize) {
          yield data
          data = []
        }
        iterCount += 1
      }
    } catch (error) {
      if (this._reader) {
        log.warn('unexpected error', error)
      } else {
        log.info('reader canceled with some reasons')
      }
      return
    } finally {
      this._toAbort = false
      this._closeReader()
      this._isLoading = false
    }
  }

  /**
   * 中断
   */
  async abort() {
    this._toAbort = true
    let interval = 10
    return await new Promise((resolve) => {
      let waitedMs = 0
      let intervalId = setInterval(() => {
        if (!this._reader) {
          clearInterval(intervalId)
          waitedMs !== 0 && log.info('load aborted')
          this._toAbort = false
          resolve()
        }
        waitedMs += interval
        // タイムアウト設定時間経過しても完了しない場合は強制的に終わらせる
        if (waitedMs > this._abortTimeoutMs) {
          clearInterval(intervalId)
          log.warn('Aborting timeout. force close reader.')
          this._closeReader()
          this._toAbort = false
          this._isLoading = false
          resolve()
        }
      }, interval)
    })
  }

  /**
   * reader を close する
   */
  _closeReader() {
    if (this._reader) {
      this._reader.cancel()
      this._reader = null
      log.info('reader closed')
    }
  }
}
